import axios from 'axios';

export function findVessel(name, confirmed, isNameSuggestion) {
    let data =
        confirmed === 'undefined'
            ? { query: name }
            : { query: name, confirmed };
    data =
        isNameSuggestion === 'undefined'
            ? { ...data }
            : { ...data, isNameSuggestion };
    return axios({
        method: 'post',
        url: '/api/v1/vessels/find',
        data,
        withCredentials: true,
    });
}

export function checkImoNumberRegistered(imoNumber) {
    return axios({
        method: 'post',
        url: '/api/v1/vessels/find',
        data: {
            query: imoNumber,
            checkIn: ['imoNumber'],
        },
        withCredentials: true,
    })
        .then(response => response.data.data.length > 0);
}

export function getVessels({
    page,
    limit,
    notConfirmed,
    sanctioned,
    modifiedFilter,
    isNameSuggestion,
    filterCargoExclusions,
    filterTradingRestrictions,
    photosFilter = 'all',
}) {
    return axios({
        method: 'get',
        url: `/api/v1/vessels?page=${page}&limit=${limit}&notConfirmed=${notConfirmed}&photosFilter=${photosFilter}&modifiedFilter=${modifiedFilter}&isNameSuggestion=${isNameSuggestion}&cargoExclusionsUpdatedFrom=${filterCargoExclusions}&tradingRestrictionsUpdatedFrom=${filterTradingRestrictions}`,
        withCredentials: true,
        params: {
            sanctioned,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function confirmVessel(id) {
    return axios({
        method: 'put',
        url: `/api/v1/vessels/${id}/confirm`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getVessel(id) {
    return axios({
        method: 'get',
        url: `/api/v1/vessels/admin/${id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteNameSuggestion(vessel) {
    return axios({
        method: 'delete',
        url: `/api/v1/vessels/${vessel.imoNumber}/nameSuggestion`,
        data: {
            imo: +vessel.imoNumber,
        },

        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function renameVessel(vessel) {
    return axios({
        method: 'put',

        url: `/api/v1/vessels/${vessel.imoNumber}/rename`,

        data: {
            imo: +vessel.imoNumber,

            name: vessel.suggestedName.name || vessel.name,
        },

        withCredentials: true,
    })
        .then(response => response.data)

        .catch(response => response.response.data);
}

export function updateVessel(vessel) {
    return axios({
        method: 'put',
        url: `/api/v1/vessels/admin/${vessel._id}`,
        data: {
            ...vessel,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteVessel(vessel) {
    return axios({
        method: 'delete',
        url: `/api/v1/vessels/${vessel._id}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function addVessel(vessel) {
    return axios({
        method: 'post',
        url: '/api/v1/vessels/admin',
        data: {
            ...vessel,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function updateVesselImage(_id, image) {
    return axios({
        method: 'put',
        url: `/api/v1/vessels/admin/${_id}/image`,
        data: {
            images: [image],
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/vessels/vessels.js